import ApplicationController from '../support/application_controller'
import BmiMixin              from '../support/bmi_mixin'
import mixin                 from '../support/mixin'

export default class extends mixin(ApplicationController, BmiMixin) {

}
